import { App, Layout } from "antd";
import { Outlet } from "react-router-dom";
import { SettingsProvider } from "../contexts/SettingsContext";
import { UXProvider } from "../contexts/UXContext";
import AppHeader from "./AppHeader";
import Settings from "./Settings";
import MobileWarningModal from "./MobileWarningModal";

const { Content } = Layout;

function WorkspaceLayout() {
    return (
        <UXProvider>
            <SettingsProvider>
                <App style={{ height: "100vh", width: "100vw" }}>
                    <Layout style={{
                        height: "100%",
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        flex: 1
                    }}>
                        <MobileWarningModal />
                        <Settings />
                        <AppHeader />
                        <Content
                            style={{
                                height: "100%",
                                width: "100%",
                                padding: "10px",
                                overflowY: "auto",
                                flex: 1,
                                display: "flex",
                                flexDirection: "column"
                            }}>
                            <Outlet /> {/* Render child routes */}
                        </Content>
                    </Layout>
                </App>
            </SettingsProvider>
        </UXProvider>
    );
}

export default WorkspaceLayout;
